<ng-container *mobxAutorun>
  <ng-container *ngIf="shouldDisplay">
    <div class="row label">
      <!-- Code + label -->
      <div class="code-label-container">
        <!-- Code -->
        <div
          *ngIf="code"
          class="input-group input-group-sm code-container mr-2"
          [class.is-warning]="relativeStorage.shouldShowWarning()"
          [class.is-invalid]="relativeStorage.shouldShowError()"
        >
          <div class="input-group-prepend">
            <div class="input-group-text code">{{ code }}</div>
          </div>
        </div>

        <!-- Label -->
        <span *ngIf="label" class="label-text">{{ label }}</span>
        <lf-help-tooltip
          *ngIf="helpMessage"
          [help]="helpMessage"
        ></lf-help-tooltip>
      </div>

      <!-- Table actions -->
      <lf-actions-menu
        class="table-actions text-right"
        [actions]="_tableActions"
        buttonsSize="sm"
        [alignMenusRight]="true"
      >
      </lf-actions-menu>
    </div>

    <!-- Required icon -->
    <lf-icon
      class="is-required"
      icon="asterisk"
      *ngIf="_showIsRequired && !isReadOnly"
    ></lf-icon>

    <!-- Pending validation -->
    <div
      class="status pending"
      *ngIf="relativeStorage.shouldShowPending()"
    ></div>
    <!-- Rejected validation -->
    <div
      class="status rejected"
      *ngIf="relativeStorage.shouldShowRejected()"
      (click)="relativeStorage.recomputeStateProperties()"
    >
      <lf-tooltip [help]="retryValidateText">
        <lf-icon icon="warning"></lf-icon>
      </lf-tooltip>
    </div>

    <!-- (Debug) value state -->
    <lf-value-state [path]="path"></lf-value-state>

    <!-- Container of whole table -->
    <div
      #targetElement
      class="table-container"
      [class.is-warning]="relativeStorage.shouldShowWarning()"
      [class.is-invalid]="relativeStorage.shouldShowError()"
    >
      <!-- Header table container (scrollable horizontally) -->
      <div #scrollableHeader class="scrollable-header" *ngIf="_tableHeader">
        <table
          class="table table-sm header-table"
          [style.minWidth]="_tableMinWidth(true) + 'px'"
          [style.maxWidth]="_tableMaxWidth(true) + 'px'"
        >
          <!-- Table columns -->
          <colgroup>
            <col
              *ngFor="let width of _columnWidths(true)"
              [attr.width]="width"
            />
          </colgroup>

          <!-- Table header -->
          <thead>
            <tr *ngFor="let row of _tableHeader.rows; let first = first">
              <!-- Selection column -->
              <th
                *ngIf="first && allowsRowRemoval"
                class="table-cell-select"
                [attr.rowSpan]="_tableHeader.numberOfRows"
              >
                <label
                  class="select-all-checkbox custom-control custom-checkbox"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    [disabled]="_value.length === 0"
                    [checked]="allRowsSelected && _value.length > 0"
                    [indeterminate]="!allRowsSelected && !noRowsSelected"
                    (click)="toggleAllRowsSelectedStatus()"
                  />
                  <span class="custom-control-label"></span>
                </label>
              </th>
              <!-- User defined columns -->
              <th
                *ngFor="let column of row"
                [attr.rowSpan]="column.rowSpan"
                [attr.colSpan]="column.colSpan"
              >
                <!-- TODO: Allow help messages/templates? -->
                <ng-container *ngIf="column.id">{{
                  _columnLabel(column.id)
                }}</ng-container>
              </th>
              <!-- Scrollbar compensation column -->
              <th *ngIf="first" [attr.rowSpan]="_tableHeader.numberOfRows"></th>
            </tr>
          </thead>
        </table>
      </div>

      <!-- Body table container (scrollable content) -->
      <cdk-virtual-scroll-viewport
        #scrollableBody
        class="scrollable-body"
        [itemSize]="rowHeight"
        [style.height]="_scrollableBodyHeight + 'px'"
      >
        <table
          class="table table-sm body-table"
          [style.minWidth]="_tableHeader && _tableMinWidth(false) + 'px'"
          [style.maxWidth]="_tableHeader && _tableMaxWidth(false) + 'px'"
        >
          <!-- Table columns (except scrollbar column) -->
          <colgroup *ngIf="_tableHeader">
            <col
              *ngFor="let width of _columnWidths(false)"
              [attr.width]="width"
            />
          </colgroup>

          <!-- Table body -->
          <tbody>
            <!-- Row -->
            <ng-container
              *cdkVirtualFor="
                let item of _value;
                let index = index;
                let count = count;
                let first = first;
                let last = last;
                let even = even;
                let odd = odd;
                templateCacheSize: virtualScrollTemplateCacheSize;
                trackBy: _trackBy
              "
              [ngTemplateOutlet]="_rowTemplate"
              [ngTemplateOutletContext]="{
                $implicit: item,
                id: _id(item, index),
                index: index,
                count: count,
                first: first,
                last: last,
                even: even,
                odd: odd
              }"
            ></ng-container>
          </tbody>
        </table>
      </cdk-virtual-scroll-viewport>

      <!-- No items -->
      <div *ngIf="_value.length === 0" class="no-rows">
        <ng-container *ngIf="!_noRowsTemplate">
          {{ _noRowsText }}
        </ng-container>
        <ng-container
          *ngIf="_noRowsTemplate"
          [ngTemplateOutlet]="_noRowsTemplate"
        >
        </ng-container>
      </div>
    </div>

    <!-- Legend -->
    <div *ngIf="legend" class="legend">{{ legend }}</div>
  </ng-container>
</ng-container>
